import React from "react";
import { useHistory } from "react-router-dom";
import { StyledIntegrateFMsgContainer, StyledSolvingProblemsIlustrationContainer, StyledInnerIntegrateFMsg } from "./audiences.style";
import { ReactComponent as SolvingProblems } from "../../../img/SolvingProblems.svg";

const IntegrateFBMsg = ({ code }) => {
	const history = useHistory();

	return (
		<StyledIntegrateFMsgContainer>
			<StyledSolvingProblemsIlustrationContainer>
				<SolvingProblems />
			</StyledSolvingProblemsIlustrationContainer>
			<StyledInnerIntegrateFMsg>
				<h3>Facebook Audiences</h3>
				<p>Connect Fixel with your Facebook Ads account for simple audience management</p>
				<button
					type="button"
					onClick={() => {
						history.push(`/segments/edit/${code}/facebook`);
					}}>
					Integrate
				</button>
			</StyledInnerIntegrateFMsg>
		</StyledIntegrateFMsgContainer>
	);
};
export default IntegrateFBMsg;
